import { useParams } from "react-router-dom";
const appNameObj = {
  "spoty-parking": "Spoty Parking",
  "guia-de-bolso-cristao": "Guia de Bolso",
  freshcura: "Freshcura",
  "little-pilgrim": "Little Pilgrim",
  default: "Castro e Mello Apps",
};

export default function TermsAndConditions() {
  let { app } = useParams<{ app: keyof typeof appNameObj }>();
  console.log(app);
  // app -> spoty-parking
  // app -> guia-de-bolso-cristao
  const appName = appNameObj[app || "default"];

  return (
    <div className="container px-4 mx-auto sm:px-6 lg:px-8 mb-12">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold my-6">Termos e Condições</h1>
        <p className="my-4">Última atualização: 30/01/2024</p>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">1. Introdução</h2>
          <p>
            Estes Termos e Condições regem o uso do aplicativo "{appName}", um
            serviço destinado ao aprendizado de inglês. Ao acessar e usar o "
            {appName}", você concorda em cumprir estes Termos e todas as leis e
            regulamentos aplicáveis.
          </p>
        </section>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">
            2. Licença para Usar o Aplicativo
          </h2>
          <p>
            "{appName}" concede a você uma licença limitada, não exclusiva e
            revogável para acessar e usar o aplicativo para seu uso pessoal e
            não comercial, sujeito aos termos deste documento.
          </p>
        </section>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">
            3. Contas e Assinaturas
          </h2>
          <p>
            Algumas seções do aplicativo estão disponíveis gratuitamente,
            enquanto outras requerem uma assinatura paga para desbloqueio. Os
            detalhes da assinatura, incluindo preços e benefícios, são
            especificados dentro do aplicativo.
          </p>
        </section>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">
            4. Cancelamento e Reembolso
          </h2>
          <p>
            Os usuários podem cancelar suas assinaturas a qualquer momento. Os
            detalhes da política de cancelamento e reembolso estão disponíveis
            dentro do aplicativo.
          </p>
        </section>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">
            5. Propriedade Intelectual
          </h2>
          <p>
            O conteúdo fornecido pelo "{appName}", incluindo textos, gráficos,
            logos e lições, é propriedade do aplicativo ou de seus licenciadores
            e é protegido por leis de propriedade intelectual.
          </p>
        </section>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">
            6. Modificações nos Termos
          </h2>
          <p>
            "{appName}" reserva-se o direito de modificar estes Termos a
            qualquer momento. Sua continuação do uso do aplicativo após tais
            mudanças constituirá seu consentimento a tais mudanças.
          </p>
        </section>

        <section className="my-8">
          <h2 className="text-2xl font-semibold mb-4">7. Contato</h2>
          <p>
            Se você tiver alguma dúvida sobre estes Termos, por favor, entre em
            contato conosco através de [seu método de contato preferido].
          </p>
        </section>
      </div>
    </div>
  );
}
